import { types as productsTypes } from "reducers/products";

export const types = {
    DOWNLOAD_PAYMENT_REQUEST: "loans/DOWNLOAD_PAYMENT_REQUEST",
    DOWNLOAD_PAYMENT_FAILURE: "loans/DOWNLOAD_PAYMENT_FAILURE",
    DOWNLOAD_PAYMENT_SUCCESS: "loans/DOWNLOAD_PAYMENT_SUCCESS",
    LIST_LOANS_REQUEST: "loans/LIST_LOANS_REQUEST",
    LIST_LOANS_SUCCESS: "loans/LIST_LOANS_SUCCESS",
    LIST_LOANSV2_REQUEST: "loans/LIST_LOANSV2_REQUEST",
    LIST_LOANSV2_SUCCESS: "loans/LIST_LOANSV2_SUCCESS",

    LOAN_DETAILS_REQUEST: "loans/LOAN_DETAILS_REQUEST",
    LOAN_DETAILS_SUCCESS: "loans/LOAN_DETAILS_SUCCESS",
    LOAN_READ_REQUEST: "loans/LOAN_READ_REQUEST",
    LOAN_READ_SUCCESS: "loans/LOAN_READ_SUCCESS",
    LOAN_LOADED_SUCCESS: "loans/LOAN_LOADED_SUCCESS",
    SET_SELECTED_LOAN: "loans/SET_SELECTED_LOAN",
    LOAN_FETCH_MORE_STATEMENTS_REQUEST: "loans/LOAN_FETCH_MORE_STATEMENTS_REQUEST",
    LOAN_FETCH_MORE_STATEMENTS_SUCCESS: "loans/LOAN_FETCH_MORE_STATEMENTS_SUCCESS",
    TOGGLE_OPTIONS: "loans/TOGGLE_OPTIONS",
    CLOSE_OPTIONS: "loans/CLOSE_OPTIONS",
    SET_SELECTED_FILTER: "loans/SET_SELECTED_FILTER",
    SET_SELECTED_STATEMENT: "loans/SET_SELECTED_STATEMENT",
    LOAN_DETAILS_CLEAR: "loans/LOAN_DETAILS_CLEAR",
    LOAN_DETAILS_SELECTED: "loans/LOAN_DETAILS_SELECTED",

    // UNSECURED LOANS APPLICATION
    UNSECURED_LOANS_APPLICATION_PRE_REQUEST: "loans/UNSECURED_LOANS_APPLICATION_PRE_REQUEST",
    UNSECURED_LOANS_APPLICATION_PRE_SUCCESS: "loans/UNSECURED_LOANS_APPLICATION_PRE_SUCCESS",
    UNSECURED_LOANS_APPLICATION_PRE_FAILURE: "loans/UNSECURED_LOANS_APPLICATION_PRE_FAILURE",

    UNSECURED_LOANS_APPLICATION_PREVIEW_REQUEST: "loans/UNSECURED_LOANS_APPLICATION_PREVIEW_REQUEST",
    UNSECURED_LOANS_APPLICATION_PREVIEW_SUCCESS: "loans/UNSECURED_LOANS_APPLICATION_PREVIEW_SUCCESS",
    UNSECURED_LOANS_APPLICATION_PREVIEW_FAILURE: "loans/UNSECURED_LOANS_APPLICATION_PREVIEW_FAILURE",

    UNSECURED_LOAN_APPLICATION_SET_BUTTON_LOADING: "loans/UNSECURED_LOAN_APPLICATION_SET_BUTTON_LOADING",
    UNSECURED_LOAN_SET_LOADING: "loans/UNSECURED_LOAN_SET_LOADING",

    UNSECURED_LOAN_APPLICATION_SEND_REQUEST: "loans/UNSECURED_LOAN_APPLICATION_SEND_REQUEST",
    UNSECURED_LOAN_APPLICATION_SEND_FAILURE: "loans/UNSECURED_LOAN_APPLICATION_SEND_FAILURE",
    UNSECURED_LOAN_APPLICATION_SEND_SUCCESS: "loans/UNSECURED_LOAN_APPLICATION_SEND_SUCCESS",

    DOWNLOAD_UNSECURED_LOANS_APPLICATION_REQUEST: "loans/DOWNLOAD_UNSECURED_LOANS_APPLICATION_REQUEST",
    DOWNLOAD_UNSECURED_LOANS_APPLICATION_FAILURE: "loans/DOWNLOAD_UNSECURED_LOANS_APPLICATION_FAILURE",
    DOWNLOAD_UNSECURED_LOANS_APPLICATION_SUCCESS: "loans/DOWNLOAD_UNSECURED_LOANS_APPLICATION_SUCCESS",

    DOWNLOAD_UNSECURED_LOANS_TERMS_REQUEST: "loans/DOWNLOAD_UNSECURED_LOANS_TERMS_REQUEST",
    DOWNLOAD_UNSECURED_LOANS_TERMS_FAILURE: "loans/DOWNLOAD_UNSECURED_LOANS_TERMS_FAILURE",
    DOWNLOAD_UNSECURED_LOANS_TERMS_SUCCESS: "loans/DOWNLOAD_UNSECURED_LOANS_TERMS_SUCCESS",

    DOWNLOAD_UNSECURED_LOAN_DETAIL_REQUEST: "loans/DOWNLOAD_UNSECURED_LOAN_DETAIL_REQUEST",
    DOWNLOAD_UNSECURED_LOAN_DETAIL_FAILURE: "loans/DOWNLOAD_UNSECURED_LOAN_DETAIL_FAILURE",
    DOWNLOAD_UNSECURED_LOAN_DETAIL_SUCCESS: "loans/DOWNLOAD_UNSECURED_LOAN_DETAIL_SUCCESS",

    DOWNLOAD_UNSECURED_LOAN_FEE_DETAIL_REQUEST: "loans/DOWNLOAD_UNSECURED_LOAN_FEE_DETAIL_REQUEST",
    DOWNLOAD_UNSECURED_LOAN_FEE_DETAIL_FAILURE: "loans/DOWNLOAD_UNSECURED_LOAN_FEE_DETAIL_FAILURE",
    DOWNLOAD_UNSECURED_LOAN_FEE_DETAIL_SUCCESS: "loans/DOWNLOAD_UNSECURED_LOAN_FEE_DETAIL_SUCCESS",

    DETALLE_PRESTAMO_REQUEST: "loans/DETALLE_PRESTAMO_REQUEST",
    DETALLE_PRESTAMO_SUCCESS: "loans/DETALLE_PRESTAMO_SUCCESS",
    DETALLE_PRESTAMO_FAILURE: "loans/DETALLE_PRESTAMO_FAILURE",

    CANCELACION_ANTICIPADA_REQUEST: "loans/CANCELACION_ANTICIPADA_REQUEST",
    DCANCELACION_ANTICIPADA_SUCCESS: "loans/DCANCELACION_ANTICIPADA_SUCCESS",
    DCANCELACION_ANTICIPADA_FAILURE: "loans/DCANCELACION_ANTICIPADA_FAILURE",

    CANCELACION_ANTICIPADA_PREVIEW_REQUEST: "loans/CANCELACION_ANTICIPADA_PREVIEW_REQUEST",
    CANCELACION_ANTICIPADA_PREVIEW_SUCCESS: "loans/DCANCELACION_ANTICIPADA_PREVIEW_SUCCESS",
    CANCELACION_ANTICIPADA_PREVIEW_FAILURE: "loans/DCANCELACION_ANTICIPADA_PREVIEW_FAILURE",

    CANCELACION_ANTICIPADA_PAYOFF_REQUEST: "loans/CANCELACION_ANTICIPADA_PAYOFF_REQUEST",
    DCANCELACION_ANTICIPADA_PAYOFF_SUCCESS: "loans/DCANCELACION_ANTICIPADA_PAYOFF_SUCCESS",
    DCANCELACION_ANTICIPADA_PAYOFF_FAILURE: "loans/DCANCELACION_ANTICIPADA_PAYOFF_FAILURE",

    OTROS_PRODUCTOS_REQUEST: "loans/OTROS_PRODUCTOS_REQUEST",
    OTROS_PRODUCTOS_SUCCESS: "loans/OTROS_PRODUCTOS_SUCCESS",
    OTROS_PRODUCTOS_FAILURE: "loans/OTROS_PRODUCTOS_FAILURE",

    CUSTOM_LOANS_APPLICATION_CONFIRM: "loans/CUSTOM_LOANS_APPLICATION_CONFIRM",

    CUSTOM_LOAN_REQUEST: "loans/CUSTOM_LOAN_REQUEST",
    CUSTOM_LOAN_FAILURE: "loans/CUSTOM_LOAN_FAILURE",
    CUSTOM_LOAN_SUCCESS: "loans/CUSTOM_LOAN_SUCCESS",

    REQUEST_UNSECURED_LOAN: "loans/REQUEST_UNSECURED_LOAN",

    GET_RATES_REQUEST: "loans/GET_RATES_REQUEST",
    GET_RATES_FAILURE: "loans/GET_RATES_FAILURE",
    GET_RATES_SUCCESS: "loans/GET_RATES_SUCCESS",

    DOWNLOAD_LOANS_DETAIL_REQUEST: "loans/DOWNLOAD_LOANS_DETAIL_REQUEST",
    DOWNLOAD_LOANS_DETAIL_FAILURE: "loans/DOWNLOAD_LOANS_DETAIL_FAILURE",
    DOWNLOAD_LOANS_DETAIL_SUCCESS: "loans/DOWNLOAD_LOANS_DETAIL_SUCCESS",

    SET_FILTERS: "loans/SET_FILTERS",
    CLEAR_FILTERS: "loans/CLEAR_FILTERS",
};

export const INITIAL_STATE = {
    fetchingDownload: false,
    fetchingCancelation: false,
    fetchingSimulation: false,
    selectedLoan: null,
    statements: null,
    moreStatements: false,
    pageNumber: 1,
    fetching: false,
    isFetchingDetail: false,
    isOptionsVisible: false,
    selectedFilter: "allFees",
    selectedStatement: null,
    amortizedLoans: null,
    propertiesLoans: null,
    loansList: [],
    activeLoans: [],
    historicalLoans: [],
    cancelacionPreview: {},
    cancelacionSend: {},
    totalCount: true,
    // UNSECURED LOANS APPLICATION
    loansSubproducts: [],
    unsecuredLoanProduct: null,
    currency: null,
    destinyFundList: [],
    periodicityList: [],
    detallePrestamo: {},
    detailSubproductLoan: null,
    qualificationLimit: null,
    qualificationAvailable: null,
    totalOwedAmount: null,
    loanSimulation: null,
    requestLoanSimulation: null,
    statusLoan: null,
    minAmount: null,
    maxAmount: null,
    documentLastBalance: null,
    documentSalesAfterBalance: null,
    documentCashflow: null,
    destinyFund: null,
    rates: [],
    preferentialRates: [],
    filters: {
        loanNumber: null,
        creditedAmount: null,
    },
    filteredLoans: [],
};

export default (state = INITIAL_STATE, action = {}) => {
    const {
        statements,
        moreStatements,
        totalCount,
        selectedStatement,
        loansList,
        activeLoans,
        historicalLoans,
        alias,
        statementSelected,
        subproducts,
        product,
        currency,
        destinyFundList,
        detallePrestamo,
        periodicityList,
        detailSubproductLoan,
        qualificationAvailable,
        qualificationLimit,
        loanSimulation,
        totalOwedAmount,
        statusLoan,
        cancelacionPreview,
        cancelacionSend,
        loading,
        minAmount,
        maxAmount,
        loanType,
        filters,
        filteredLoans,
        ...rest
    } = action;

    switch (action.type) {
        case types.DOWNLOAD_PAYMENT_REQUEST:
            return {
                ...state,
                fetchingDownload: true,
            };
        case types.DOWNLOAD_PAYMENT_FAILURE:
        case types.DOWNLOAD_PAYMENT_SUCCESS:
            return {
                ...state,
                fetchingDownload: false,
            };
        case types.LIST_LOANS_REQUEST:
            return {
                ...state,
                isOptionsVisible: false,
                fetching: true,
            };
        case types.LIST_LOANS_SUCCESS:
            return {
                ...state,
                loansList,
                fetching: false,
            };
        case types.LIST_LOANSV2_REQUEST:
            return {
                ...state,
                isOptionsVisible: false,
                fetching: true,
            };
        case types.DETALLE_PRESTAMO_SUCCESS:
            return {
                ...state,
                detallePrestamo,
                fetching: false,
            };
        case types.DETALLE_PRESTAMO_REQUEST:
            return {
                ...state,
                isOptionsVisible: false,
                fetching: true,
                fetchingCancelation: false,
            };
        case types.LIST_LOANSV2_SUCCESS:
            return {
                ...state,
                activeLoans,
                historicalLoans,
                fetching: false,
            };
        case types.LOAN_DETAILS_REQUEST:
            return {
                ...state,
                isFetchingDetail: true,
            };
        case types.LOAN_DETAILS_SUCCESS:
            // eslint-disable-next-line no-case-declarations
            const statementsResponse = statements.map((item) => ({ ...item, selected: false }));

            return {
                ...state,
                statements: statementsResponse,
                moreStatements,
                totalCount,
                pageNumber: action.pageNumber,
                isFetchingDetail: false,
                currencyStatements: currency,
                ...rest,
            };
        case types.LOAN_READ_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.LOAN_READ_SUCCESS:
            return {
                ...state,
                selectedLoan: action.loan,
                numberOfFees: action.numberOfFees,
                fetching: false,
            };
        case types.LOAN_FETCH_MORE_STATEMENTS_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.LOAN_FETCH_MORE_STATEMENTS_SUCCESS:
            return {
                ...state,
                fetching: false,
                statements: state.statements.concat(statements),
                moreStatements,
                totalCount,
                ...rest,
            };
        case types.LOAN_LOADED_SUCCESS:
            return {
                ...state,
                fetching: false,
                isFetchingDetail: false,
            };
        case types.TOGGLE_OPTIONS: {
            return {
                ...state,
                isOptionsVisible: !state.isOptionsVisible,
            };
        }
        case types.CLOSE_OPTIONS:
            return {
                ...state,
                isOptionsVisible: false,
            };
        case types.SET_SELECTED_FILTER:
            return {
                ...state,
                selectedFilter: action.selectedFilter,
            };
        case types.SET_SELECTED_STATEMENT:
            return {
                ...state,
                selectedStatement,
            };
        case productsTypes.CHANGE_PRODUCT_ALIAS_SUCCESS: {
            return {
                ...state,
                selectedLoan: {
                    ...state.selectedLoan,
                    productAlias: alias,
                },
            };
        }
        case types.LOAN_DETAILS_CLEAR:
            return {
                ...state,
                statements: [],
            };
        case types.LOAN_DETAILS_SELECTED:
            // eslint-disable-next-line no-case-declarations
            const statementsSelect = state?.statements?.map((item) => {
                if (item.idStatement === statementSelected.idStatement) {
                    return { ...item, selected: !item.selected };
                }
                return item;
            });

            return {
                ...state,
                statements: statementsSelect,
            };
        case types.UNSECURED_LOANS_APPLICATION_PRE_REQUEST:
            return {
                ...state,
                fetching: true,
                fetchingSimulation: false,
                loansSubproducts: [],
                unsecuredLoanProduct: null,
                currency: null,
                destinyFundList: [],
                periodicityList: [],
                detailSubproductLoan: null,
                qualificationLimit: null,
                qualificationAvailable: null,
                loanSimulation: null,
                requestLoanSimulation: null,
                minAmount: null,
            };
        case types.UNSECURED_LOANS_APPLICATION_PRE_SUCCESS:
            return {
                ...state,
                fetching: false,
                loansSubproducts: subproducts,
                qualificationAvailable,
                qualificationLimit,
                periodicityList,
                destinyFundList,
                currency,
                minAmount,
                maxAmount,
            };
        case types.UNSECURED_LOANS_APPLICATION_PRE_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.UNSECURED_LOANS_APPLICATION_PREVIEW_REQUEST:
            return {
                ...state,
                fetchingSimulation: true,
                requestLoanSimulation: action.params,
                loanSimulation: null,
            };
        case types.UNSECURED_LOANS_APPLICATION_PREVIEW_SUCCESS:
            return {
                ...state,
                fetchingSimulation: false,
                loanSimulation,
            };
        case types.CANCELACION_ANTICIPADA_PREVIEW_REQUEST:
            return {
                ...state,
                fetchingCancelation: true,
            };
        case types.CANCELACION_ANTICIPADA_PREVIEW_SUCCESS:
            return {
                ...state,
                fetchingCancelation: false,
                cancelacionPreview,
            };
        case types.CANCELACION_ANTICIPADA_PREVIEW_FAILURE:
            return {
                ...state,
                fetchingCancelation: false,
            };
        case types.CANCELACION_ANTICIPADA_PAYOFF_REQUEST:
            return {
                ...state,
                fetchingCancelation: true,
            };
        case types.DCANCELACION_ANTICIPADA_PAYOFF_SUCCESS:
            return {
                ...state,
                fetchingCancelation: false,
                cancelacionSend,
            };
        case types.DCANCELACION_ANTICIPADA_PAYOFF_FAILURE:
            return {
                ...state,
                fetchingCancelation: false,
            };
        case types.UNSECURED_LOANS_APPLICATION_PREVIEW_FAILURE:
            return {
                ...state,
                fetchingSimulation: false,
                loanSimulation: null,
            };
        case types.OTROS_PRODUCTOS_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.OTROS_PRODUCTOS_FAILURE:
            return {
                ...state,
                fetching: false,
                statusLoan: action.statusLoan,
            };
        case types.OTROS_PRODUCTOS_SUCCESS:
            return {
                ...state,
                fetching: false,
            };
        case types.DOWNLOAD_ACCOUNTS_REQUEST:
            return {
                ...state,
                fetchingDownload: true,
            };
        case types.DOWNLOAD_ACCOUNTS_FAILURE:
        case types.DOWNLOAD_ACCOUNTS_SUCCESS:
            return {
                ...state,
                fetchingDownload: false,
            };
        case types.UNSECURED_LOAN_APPLICATION_SEND_REQUEST:
            return {
                ...state,
                loanApplicationInProgress: true,
            };
        case types.UNSECURED_LOAN_APPLICATION_SEND_FAILURE:
        case types.UNSECURED_LOAN_APPLICATION_SEND_SUCCESS:
            return {
                ...state,
                loanApplicationInProgress: false,
            };
        case types.UNSECURED_LOAN_APPLICATION_SET_BUTTON_LOADING:
            return {
                ...state,
                loanApplicationInProgress: loading,
            };
        case types.UNSECURED_LOAN_SET_LOADING:
            return {
                ...state,
                fetching: loading,
            };
        case types.CUSTOM_LOANS_APPLICATION_CONFIRM:
            return {
                ...state,
                ...action.params,
            };
        case types.CUSTOM_LOAN_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.CUSTOM_LOAN_SUCCESS:
            return {
                ...state,
                ...action.params,
                fetching: false,
            };
        case types.CUSTOM_LOAN_FAILURE:
            return {
                ...state,
                fetching: false,
            };

        case types.REQUEST_UNSECURED_LOAN:
            return {
                ...state,
                loanType: action.loanType,
                rate: action.rate,
                maxAmount: action.maxAmount,
            };
        case types.GET_RATES_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.GET_RATES_SUCCESS:
            return {
                ...state,
                rates: action.rates,
                preferentialRates: action.preferentialRates,
                fetching: false,
            };
        case types.GET_RATES_FAILURE:
            return {
                ...state,
                fetching: false,
            };

        case types.DOWNLOAD_LOANS_DETAIL_REQUEST:
            return { ...state, fetchingDownload: true };
        case types.DOWNLOAD_LOANS_DETAIL_FAILURE:
        case types.DOWNLOAD_LOANS_DETAIL_SUCCESS:
            return { ...state, fetchingDownload: false };

        case types.SET_FILTERS:
            return { ...state, filters, filteredLoans };
        case types.CLEAR_FILTERS:
            return { ...state, filters: INITIAL_STATE.filters, filteredLoans: INITIAL_STATE.filteredLoans };

        default:
            return state;
    }
};

export const actions = {
    listLoans: () => ({
        type: types.LIST_LOANS_REQUEST,
    }),
    listLoansV2: () => ({
        type: types.LIST_LOANSV2_REQUEST,
    }),
    getLoanDetail: (loanNumber) => ({
        type: types.DETALLE_PRESTAMO_REQUEST,
        loanNumber,
    }),
    getDataCancelacionAnticipada: (prestamo) => ({
        type: types.CANCELACION_ANTICIPADA_REQUEST,
        prestamo,
    }),
    setCancelacionAnticipadaPayOff: (
        idProduct,
        extraInfo,
        _otp,
        debitAccount,
        detallePrestamo,
        idTransaction = null,
    ) => ({
        type: types.CANCELACION_ANTICIPADA_PAYOFF_REQUEST,
        idProduct,
        extraInfo,
        _otp,
        debitAccount,
        detallePrestamo,
        idTransaction,
    }),
    gerCancelacionAnticipadaPreview: (idProduct, extraInfo, id, idTransaction = null) => ({
        type: types.CANCELACION_ANTICIPADA_PREVIEW_REQUEST,
        idProduct,
        extraInfo,
        id,
        idTransaction,
    }),
    setOtrosProductos: (email, credential, phone, comment, typeProduct, name, lastname, document, dataAll) => ({
        type: types.OTROS_PRODUCTOS_REQUEST,
        email,
        credential,
        phone,
        comment,
        typeProduct,
        name,
        lastname,
        document,
        dataAll,
    }),
    details: (selectedLoanId, filters) => ({
        type: types.LOAN_DETAILS_REQUEST,
        selectedLoanId,
        filters,
    }),
    downloadPayment: (idLoan, format) => ({
        type: types.DOWNLOAD_PAYMENT_REQUEST,
        idLoan,
        format,
    }),
    readLoan: (loanId) => ({
        type: types.LOAN_READ_REQUEST,
        loanId,
    }),
    fetchMoreStatements: (loanId, filters) => ({
        type: types.LOAN_FETCH_MORE_STATEMENTS_REQUEST,
        loanId,
        filters,
    }),
    toggleOptions: () => ({
        type: types.TOGGLE_OPTIONS,
    }),
    closeOptions: () => ({
        type: types.CLOSE_OPTIONS,
    }),
    setSelectedFilter: (selectedFilter) => ({
        type: types.SET_SELECTED_FILTER,
        selectedFilter,
    }),
    setSelectedStatement: (selectedStatement) => ({
        type: types.SET_SELECTED_STATEMENT,
        selectedStatement,
    }),
    setBackToDesktop: (backToDesktop) => ({
        type: types.SET_BACK_TO_DESKTOP,
        backToDesktop,
    }),
    loadedLoan: () => ({
        type: types.LOAN_LOADED_SUCCESS,
    }),
    clearLoanStatement: () => ({
        type: types.LOAN_DETAILS_CLEAR,
    }),
    statementSelected: (statementSelected) => ({
        type: types.LOAN_DETAILS_SELECTED,
        statementSelected,
    }),
    unsecuresLoansApplicationPre: (loanType) => ({
        type: types.UNSECURED_LOANS_APPLICATION_PRE_REQUEST,
        loanType,
    }),
    unsecuredLoansApplicationPreview: (params) => ({
        type: types.UNSECURED_LOANS_APPLICATION_PREVIEW_REQUEST,
        params,
    }),
    downloadUnsecuredLoansApplication: (unsecuredLoanPreview, accountLabel, format) => ({
        type: types.DOWNLOAD_UNSECURED_LOANS_APPLICATION_REQUEST,
        unsecuredLoanPreview,
        accountLabel,
        format,
    }),
    downloadUnsecuredLoanDetail: (loanDescription, product, installmentsStatus, format) => ({
        type: types.DOWNLOAD_UNSECURED_LOAN_DETAIL_REQUEST,
        loanDescription,
        product,
        installmentsStatus,
        format,
    }),
    downloadUnsecuredLoansApplicationTerms: () => ({
        type: types.DOWNLOAD_UNSECURED_LOANS_TERMS_REQUEST,
    }),
    unsecuredLoansApplicationSend: (params) => ({
        type: types.UNSECURED_LOAN_APPLICATION_SEND_REQUEST,
        params,
    }),
    downloadUnsecuredLoanFeeDetail: (unsecuredLoanFeeDetail, format) => ({
        type: types.DOWNLOAD_UNSECURED_LOAN_FEE_DETAIL_REQUEST,
        unsecuredLoanFeeDetail,
        format,
    }),
    unsecuredLoanAplicationSetButtonLoading: (loading) => ({
        type: types.UNSECURED_LOAN_APPLICATION_SET_BUTTON_LOADING,
        loading,
    }),
    customLoansApplicationConfirm: (params) => ({
        type: types.CUSTOM_LOANS_APPLICATION_CONFIRM,
        params,
    }),
    requestCustomLoan: (params, formikBag, credentialType) => ({
        type: types.CUSTOM_LOAN_REQUEST,
        params,
        formikBag,
        credentialType,
    }),
    requestUnsecuredLoan: (loanType, rate, maxAmount) => ({
        type: types.REQUEST_UNSECURED_LOAN,
        loanType,
        rate,
        maxAmount,
    }),

    getRates: (currency) => ({
        type: types.GET_RATES_REQUEST,
        currency,
    }),

    downloadLoansDetail: (installmentList, format) => ({
        type: types.DOWNLOAD_LOANS_DETAIL_REQUEST,
        installmentList,
        format,
    }),

    clearFilters: () => ({
        type: types.CLEAR_FILTERS,
    }),
    setFilters: (filters, filteredLoans) => ({
        type: types.SET_FILTERS,
        filters,
        filteredLoans,
    }),
};

export const selectors = {
    getLoans: ({ loans }) => loans.loansList,
    getLoansV2: ({ loans }) => loans.loansV2,
    getActiveLoans: ({ loans }) => loans.activeLoans,
    getHistoricalLoans: ({ loans }) => loans.historicalLoans,
    getSelectedLoan: ({ loans }) => loans.selectedLoan,
    getPageNumber: ({ loans }) => loans.pageNumber,
    getStatements: ({ loans }) => loans.statements,
    getMoreStatements: ({ loans }) => loans.moreStatements,
    getFetching: ({ loans }) => loans.fetching,
    getFetchingDownload: ({ loans }) => loans.fetchingDownload,
    getFetchingCancelation: ({ loans }) => loans.fetchingCancelation,
    getIsOptionsVisible: ({ loans }) => loans.isOptionsVisible,
    getSelectedFilter: ({ loans }) => loans.selectedFilter,
    getSelectedStatement: ({ loans }) => loans.selectedStatement,
    getBackToDesktop: ({ loans }) => loans.backToDesktop,
    isFetchingDetail: ({ loans }) => loans.isFetchingDetail,
    getTotalCount: ({ loans }) => loans.totalCount,
    getDetallePrestamo: ({ loans }) => loans.detallePrestamo,
    getStatusLoan: ({ loans }) => loans.statusLoan,
    getCancelacionPreview: ({ loans }) => loans.cancelacionPreview,
    getCancelacionSend: ({ loans }) => loans.cancelacionSend,
    // eslint-disable-next-line no-confusing-arrow
    getStatementsPendieng: ({ loans }) =>
        loans.statements ? loans.statements.filter((item) => item.status === "pending") : loans.statements,
    getCurrencyStatements: ({ loans }) => loans.currencyStatements,
    getUnsecuredLoanProduct: ({ loans }) => loans.unsecuredLoanProduct,
    getLoansSubproducts: ({ loans }) => loans.loansSubproducts,
    getCurrency: ({ loans }) => loans.currency,
    getDestinyFundList: ({ loans }) => loans.destinyFundList,
    getPeriodicityList: ({ loans }) => loans.periodicityList,
    getDetailSubproductLoan: ({ loans }) => loans.detailSubproductLoan,
    getQualificationAvailable: ({ loans }) => loans.qualificationAvailable,
    getTotalOwedAmount: ({ loans }) => loans.totalOwedAmount,
    getQualificationLimit: ({ loans }) => loans.qualificationLimit,
    getLoanSimulation: ({ loans }) => loans.loanSimulation,
    getRequestLoanSimulation: ({ loans }) => loans.requestLoanSimulation,
    getLoanApplicationInProgress: ({ loans }) => loans.loanApplicationInProgress,
    getMinAmount: ({ loans }) => loans.minAmount,
    getMaxAmount: ({ loans }) => loans.maxAmount,
    getRates: ({ loans }) => loans.rates,
    getPreferentialRates: ({ loans }) => loans.preferentialRates,
    getFetchingSimulation: ({ loans }) => loans.fetchingSimulation,
    getFilters: ({ loans }) => loans.filters,
    getFilteredLoans: ({ loans }) => loans.filteredLoans,
};
